import { RoleOptions, RoleSearchOptions } from 'components/Dashboard/Filters/FiltersData/StakeholdersFilters';

const staffersFilters = [...RoleOptions, ...RoleSearchOptions]?.filter((item) =>
  item?.name?.toLowerCase()?.includes('staff')
);

// The directory hides staffers by default; any query built from the directory's filters
// (table, export, send-email) must exclude them the same way or it'll return more contacts
// than the directory shows.
const getContactFiltersExcludingStaff = (filters, includeStaff) => {
  const filtersValues = staffersFilters?.map((item) => item?.filterValue ?? item?.name);
  const includeStaffers = includeStaff || filters?.some((item) => filtersValues?.includes(item?.value));

  if (includeStaffers) return filters;

  const noStaffFilter = staffersFilters?.map((item) => ({
    field: 'categories',
    value: item?.filterValue ?? item?.name,
    operator: 'str_not_eq',
  }));

  return [...noStaffFilter, ...filters];
};

export default getContactFiltersExcludingStaff;
